function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M341.318,512.019c-3.872,0-7.441-2.098-9.323-5.483l-47.275-85.099l-54.144,42.368c-4.631,3.641-11.337,2.838-14.978-1.794 c-1.477-1.879-2.28-4.2-2.281-6.59V160.019c-0.011-5.891,4.757-10.675,10.648-10.686c2.84-0.005,5.565,1.123,7.571,3.134 L444.87,365.8c4.171,4.16,4.179,10.914,0.019,15.085c-2.006,2.011-4.731,3.139-7.571,3.134h-67.2l44.523,80.149 c2.863,5.149,1.01,11.643-4.139,14.506c-0.133,0.074-0.268,0.146-0.405,0.214l-64,32 C344.615,511.636,342.978,512.023,341.318,512.019z M287.985,394.685c0.717-0.003,1.432,0.068,2.133,0.213 c3.059,0.617,5.694,2.543,7.211,5.269l48.384,87.083l44.8-22.464l-47.915-86.251c-2.863-5.148-1.011-11.643,4.138-14.506 c1.605-0.892,3.413-1.355,5.249-1.344h59.584L234.651,185.789v247.744l46.763-36.565 C283.288,395.494,285.601,394.691,287.985,394.685z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M163.121,307.069c-1.47-0.008-2.923-0.321-4.267-0.917C78.158,270.143,41.933,175.534,77.943,94.839 S208.561-22.082,289.256,13.927s116.921,130.618,80.911,211.313c-0.002,0.005-0.005,0.01-0.007,0.015 c-2.404,5.379-8.712,7.79-14.091,5.387c-5.379-2.404-7.79-8.712-5.387-14.091c31.217-69.932-0.169-151.93-70.101-183.147 s-151.93,0.169-183.147,70.101s0.169,151.93,70.101,183.147c5.384,2.39,7.812,8.692,5.422,14.077 c-1.702,3.835-5.494,6.315-9.689,6.339H163.121z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M188.017,248.083c-1.549,0-3.079-0.342-4.48-1.003c-48.071-22.366-68.909-79.467-46.543-127.537S216.461,50.634,264.531,73 s68.909,79.467,46.543,127.537c-0.002,0.005-0.004,0.01-0.007,0.015c-2.486,5.343-8.833,7.659-14.176,5.173 c-5.343-2.486-7.659-8.833-5.173-14.176c17.369-37.401,1.13-81.801-36.271-99.17s-81.801-1.13-99.17,36.271 c-17.367,37.397-1.133,81.793,36.262,99.166c5.337,2.494,7.643,8.842,5.149,14.179c-1.751,3.749-5.513,6.146-9.65,6.152 L188.017,248.083z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var SvgClicking = function SvgClicking(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.019 512.019",
    fill: "none",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M444.87,365.821L231.537,152.488c-4.16-4.171-10.914-4.179-15.085-0.019 c-2.006,2.001-3.133,4.717-3.134,7.55v295.403c-0.001,5.891,4.773,10.668,10.664,10.669c2.382,0.001,4.697-0.796,6.573-2.264 l54.165-42.347l47.275,85.099c2.806,4.961,9.016,6.84,14.101,4.267l64-32c5.267-2.639,7.397-9.048,4.758-14.315 c-0.068-0.137-0.14-0.272-0.214-0.405l-44.501-80.107h67.179c5.891,0.011,10.675-4.757,10.686-10.648 c0.005-2.84-1.123-5.565-3.134-7.571V365.821z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M163.121,307.069c-1.47-0.008-2.923-0.321-4.267-0.917C78.158,270.143,41.933,175.534,77.943,94.839 S208.561-22.082,289.256,13.927s116.921,130.618,80.911,211.313c-0.002,0.005-0.005,0.01-0.007,0.015 c-2.404,5.379-8.712,7.79-14.091,5.387c-5.379-2.404-7.79-8.712-5.387-14.091c31.217-69.932-0.169-151.93-70.101-183.147 s-151.93,0.169-183.147,70.101s0.169,151.93,70.101,183.147c5.384,2.39,7.812,8.692,5.422,14.077 c-1.702,3.835-5.494,6.315-9.689,6.339H163.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M188.017,248.083c-1.549,0-3.079-0.342-4.48-1.003c-48.071-22.366-68.909-79.467-46.543-127.537 S216.461,50.634,264.531,73s68.909,79.467,46.543,127.537c-0.002,0.005-0.004,0.01-0.007,0.015 c-2.486,5.343-8.833,7.659-14.176,5.173c-5.343-2.486-7.659-8.833-5.173-14.176c17.369-37.401,1.13-81.801-36.271-99.17 s-81.801-1.13-99.17,36.271c-17.367,37.397-1.133,81.793,36.262,99.166c5.337,2.494,7.643,8.842,5.149,14.179 c-1.751,3.749-5.513,6.146-9.65,6.152L188.017,248.083z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClicking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clicking.262367ef.svg";
export { ForwardRef as ReactComponent };